import '../../styles/table.scss';

import { ReactNode, TableHTMLAttributes, TdHTMLAttributes, ThHTMLAttributes } from 'react';

export interface TableProps extends TableHTMLAttributes<HTMLTableElement> {
  className?: string;
  captionSize?: 'xl' | 'l' | 'm' | 's';
  caption?: ReactNode;
  children?: ReactNode;
}

export default function Table({ className, captionSize, caption, children, ...props }: TableProps) {
  return (
    <table className={`govuk-table ${className}`} {...props}>
      {!!caption && (
        <caption className={`govuk-table__caption govuk-table__caption--${captionSize}`}>{caption}</caption>
      )}
      {children}
    </table>
  );
}

export interface ItemProps {
  className?: string;
  children?: ReactNode;
}

export function THead({ className, children }: ItemProps) {
  return <thead className={`govuk-table__head ${className}`}>{children}</thead>;
}

export function TBody({ className, children }: ItemProps) {
  return <tbody className={`govuk-table__body ${className}`}>{children}</tbody>;
}

export function TR({ className, children }: ItemProps) {
  return <tr className={`govuk-table__row ${className}`}>{children}</tr>;
}

export interface TDProps extends TdHTMLAttributes<HTMLTableCellElement> {
  isNumeric?: boolean;
  className?: string;
  children?: ReactNode;
  width?: 'full' | 'one-half' | 'one-third' | 'two-thirds' | 'one-quarter' | 'three-quarters';
}

export function TD({ isNumeric, className, children, ...props }: TDProps) {
  const numericClass = isNumeric ? 'govuk-table__cell--numeric' : '';
  const widthClass = props.width ? `govuk-!-width-${props.width}` : '';
  return (
    <td className={`govuk-table__cell ${widthClass} ${numericClass} ${className ?? ''}`} {...props}>
      {children}
    </td>
  );
}

export interface THProps extends ThHTMLAttributes<HTMLTableCellElement> {
  isNumeric?: boolean;
  className?: string;
  scope?: 'col' | 'row';
  children?: ReactNode;
}

export function TH({ isNumeric, className, scope = 'row', children, ...props }: THProps) {
  const numericClass = isNumeric ? 'govuk-table__header--numeric' : '';
  return (
    <th scope={scope} className={`govuk-table__header ${numericClass} ${className ?? ''}`} {...props}>
      {children}
    </th>
  );
}
